export class saveSystemSettingRequest {
    id?: string;
    freeTrialPeriodDays!: number;
    // freeTrialPeriodMinutes!: number;
}

export class SystemSettings {
    Id!: string;
    FreeTrialPeriodDays!: number;
    // FreeTrialPeriodMinutes!: number;
}